export const POST_METHOD_HANDLER_FOR_SCHEMEMASTER_API = "POST_METHOD_HANDLER_FOR_SCHEMEMASTER_API"
export const POST_METHOD_HANDLER_FOR_SCHEMEMASTER_API_SUCCESS = "POST_METHOD_HANDLER_FOR_SCHEMEMASTER_API_SUCCESS"

export const GET_SCHEME_LIST = "GET_SCHEME_LIST"
export const GET_SCHEME_LIST_SUCCESS = "GET_SCHEME_LIST_SUCCESS"


export const DELETE_SCHEME_LIST_ID = "DELETE_SCHEMEMASTER_ID"
export const DELETE_SCHEME_LIST_ID_SUCCESS = "DELETE_SCHEMEMASTER_ID_SUCCESS"

export const EDIT_SCHEMEMASTER_ID = "EDIT_SCHEMEMASTER_ID"
export const EDIT_SCHEMEMASTER_ID_SUCCESS = "EDIT_SCHEMEMASTER_ID_SUCCESS"

export const UPDATE_SCHEMEMASTER_ID = "UPDATE_SCHEMEMASTER_ID"
export const UPDATE_SCHEMEMASTER_ID_SUCCESS = "UPDATE_SCHEMEMASTER_ID_SUCCESS"

export const SAVE_SCHEME_MASTER = "SAVE_SCHEME_MASTER"
export const SAVE_SCHEME_MASTER_SUCCESS = "SAVE_SCHEME_MASTER_SUCCESS"


export const UPLOAD_VOUCHER = "UPLOAD_VOUCHER"
export const UPLOAD_VOUCHER_SUCCESS = "UPLOAD_VOUCHER_SUCCESS"


export const DELETE_VOUCHERS_BY_SCHEME = "DELETE_VOUCHERS_BY_SCHEME"
export const DELETE_VOUCHERS_BY_SCHEME_SUCCESS = "DELETE_VOUCHERS_BY_SCHEME_SUCCESS"


export const SCHEME_API_ERROR_ACTION = "SCHEME_API_ERROR_ACTION"


